import { Drawer } from '@carboncopyco/ui';
import { EditsMenu, type EditsMenuProps } from './EditsMenu';

export interface ChangesTrackerDrawerProps
  extends Pick<EditsMenuProps, 'edits'> {
  open: boolean;
  onClose: () => void;
}

export const ChangesTrackerDrawer = ({
  open,
  onClose,
  edits,
}: ChangesTrackerDrawerProps) => {
  return (
    <Drawer
      width={400}
      header="Change history"
      isOpen={open}
      onClose={onClose}
    >
      <div className="px-4">
        <EditsMenu edits={edits} />
      </div>
    </Drawer>
  );
};
